<template>
  <div class="block block-cust">
    <div class="container">
      <div class="title title-cust">
        <span v-if="isMobile"> 留下您的联系方式 </span>
        <span v-else> 留下您的联系方式，让我们专业顾问为您解答演示 </span>
      </div>
      <InputPhone />
    </div>
  </div>
</template>

<script>
import InputPhone from "@/components/InputPhone.vue";
export default {
  components: {
    InputPhone,
  },
};
</script>

<style scoped>
.block-cust {
  background-color: #f6f8fc;
  padding: 100px 0;
}

.title-cust {
  color: #3975ea;
  margin-bottom: 60px;
}

/*  */
.mb .block-cust {
  padding: 30px 0;
}
</style>